document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initContador();
  initPasosCarrusel();
  initGaleriaProducto();
  initVariantesProducto();
  initGiroProducto();
});

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mt-visible');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(function (el) { obs.observe(el); });
}

function initContador() {
  var els = document.querySelectorAll('.mt-contador');
  if (!els.length) return;
  var animate = function (el) {
    var target = parseFloat(el.dataset.target || '0');
    var duration = 1400;
    var start = null;
    var decimals = (el.dataset.target || '').includes('.') ? 1 : 0;
    function step(ts) {
      if (!start) start = ts;
      var progress = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var value = target * eased;
      el.textContent = value.toFixed(decimals);
      if (progress < 1) requestAnimationFrame(step);
      else el.textContent = target.toFixed(decimals);
    }
    requestAnimationFrame(step);
  };
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        animate(entry.target);
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.4 });
  els.forEach(function (el) { obs.observe(el); });
}

function initPasosCarrusel() {
  var wraps = document.querySelectorAll('[data-mt-pasos]');
  wraps.forEach(function (wrap) {
    var btns = wrap.querySelectorAll('[data-mt-paso-btn]');
    var panels = wrap.querySelectorAll('[data-mt-paso-panel]');
    if (!btns.length) return;
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = btn.dataset.mtPasoBtn;
        btns.forEach(function (b) { b.classList.remove('is-active'); });
        panels.forEach(function (p) { p.classList.remove('is-active'); });
        btn.classList.add('is-active');
        var panel = wrap.querySelector('[data-mt-paso-panel="' + idx + '"]');
        if (panel) panel.classList.add('is-active');
      });
    });
  });
}

function initGaleriaProducto() {
  var galerias = document.querySelectorAll('[data-mt-galeria]');
  galerias.forEach(function (galeria) {
    var principal = galeria.querySelector('[data-mt-img-principal]');
    var minis = galeria.querySelectorAll('[data-mt-mini]');
    if (!principal || !minis.length) return;
    minis.forEach(function (mini) {
      mini.addEventListener('click', function () {
        var full = mini.dataset.full;
        if (full) principal.src = full;
        minis.forEach(function (m) { m.classList.remove('is-active'); });
        mini.classList.add('is-active');
      });
    });
  });
}

function initGiroProducto() {
  var spins = document.querySelectorAll('[data-mt-spin]');
  spins.forEach(function (spin) {
    var frames = spin.querySelectorAll('.mt-prod__spin-frame');
    if (frames.length < 2) return;
    var idx = 0;
    setInterval(function () {
      frames[idx].classList.remove('is-active');
      idx = (idx + 1) % frames.length;
      frames[idx].classList.add('is-active');
    }, 1400);

    var galeria = spin.closest('[data-mt-galeria]');
    if (!galeria) return;
    var minis = galeria.querySelectorAll('[data-mt-mini]');
    minis.forEach(function (mini) {
      mini.addEventListener('click', function () {
        spin.classList.add('is-oculto');
      });
    });
  });
}

function initVariantesProducto() {
  var formularios = document.querySelectorAll('[data-mt-producto]');
  formularios.forEach(function (wrap) {
    var datosEl = wrap.parentElement.querySelector('[data-mt-prod-variantes]');
    if (!datosEl) return;
    var variantes;
    try {
      variantes = JSON.parse(datosEl.textContent);
    } catch (e) {
      return;
    }
    var selects = wrap.querySelectorAll('[data-mt-opcion-indice]');
    var inputId = wrap.querySelector('[data-mt-variant-id]');
    var precioActual = wrap.parentElement.querySelector('[data-mt-precio-actual]');
    var precioAnterior = wrap.parentElement.querySelector('[data-mt-precio-anterior]');
    var boton = wrap.querySelector('[data-mt-boton]');
    var botonTexto = wrap.querySelector('[data-mt-boton-texto]');
    var galeria = wrap.closest('.mt-prod__grid') ? wrap.closest('.mt-prod__grid').querySelector('[data-mt-img-principal]') : null;
    var textoAgotado = boton && boton.querySelector('.sold-out-message') ? boton.querySelector('.sold-out-message').textContent.trim() : 'Agotado';
    var textoDisponible = botonTexto ? botonTexto.textContent.trim() : 'Añadir al carrito';

    function actualizar() {
      var seleccion = [];
      selects.forEach(function (sel) { seleccion.push(sel.value); });
      var variante = variantes.find(function (v) {
        return v.opciones.length === seleccion.length && v.opciones.every(function (val, i) { return val === seleccion[i]; });
      });
      if (!variante) return;
      if (inputId) inputId.value = variante.id;
      if (precioActual) precioActual.textContent = variante.precio;
      if (precioAnterior) {
        if (variante.precio_comparado) {
          precioAnterior.textContent = variante.precio_comparado;
          precioAnterior.hidden = false;
        } else {
          precioAnterior.hidden = true;
        }
      }
      if (boton && botonTexto) {
        if (variante.disponible) {
          boton.removeAttribute('aria-disabled');
          botonTexto.textContent = textoDisponible;
        } else {
          boton.setAttribute('aria-disabled', 'true');
          botonTexto.textContent = textoAgotado;
        }
      }
      if (galeria && variante.imagen) galeria.src = variante.imagen;
    }

    selects.forEach(function (sel) { sel.addEventListener('change', actualizar); });
  });
}
